import { ArrowDown, ArrowUp, DotsSixVertical, PencilSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Pill } from "@/components/admin/AdminUI";

export default function PromptRow({ p, index, total, dragging, onMove, onToggle, onEdit, onDragStart, onDragEnd, onDragOver }) {
  return (
    <li draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; onDragStart(); }} onDragEnd={onDragEnd}
      onDragOver={(e) => { e.preventDefault(); onDragOver(); }}
      className={`flex items-center gap-3 px-3 py-4 transition-colors cw-ease sm:px-5 ${dragging ? "cw-bg-tint opacity-70" : "bg-white"}`}
      data-testid={`prompt-row-${p.id}`}>
      <span className="cw-muted hidden cursor-grab active:cursor-grabbing sm:block" aria-hidden><DotsSixVertical size={20} /></span>
      <span className="cw-muted w-6 text-right text-xs tabular-nums" data-testid={`prompt-position-${p.id}`}>{index + 1}</span>
      <div className="min-w-0 flex-1">
        <p className={`text-sm font-medium ${p.active ? "" : "cw-muted"}`} data-testid={`prompt-text-${p.id}`}>{p.text}</p>
        <p className="cw-muted mt-1 flex flex-wrap items-center gap-2 text-xs">
          <span data-testid={`prompt-usage-${p.id}`}>used by {p.usage_count ?? 0} profile{p.usage_count === 1 ? "" : "s"}</span>
          {!p.active && <Pill>Off</Pill>}
        </p>
      </div>
      <div className="flex items-center gap-1">
        <Button size="icon" variant="ghost" disabled={index === 0} onClick={() => onMove(index - 1)} aria-label={`Move "${p.text}" up`} data-testid={`prompt-up-button-${p.id}`}><ArrowUp /></Button>
        <Button size="icon" variant="ghost" disabled={index === total - 1} onClick={() => onMove(index + 1)} aria-label={`Move "${p.text}" down`} data-testid={`prompt-down-button-${p.id}`}><ArrowDown /></Button>
        <Button size="icon" variant="ghost" onClick={onEdit} aria-label={`Edit "${p.text}"`} data-testid={`prompt-edit-button-${p.id}`}><PencilSimple /></Button>
        <Switch checked={!!p.active} onCheckedChange={onToggle} aria-label={`${p.active ? "Turn off" : "Turn on"} "${p.text}"`} className="ml-2" data-testid={`prompt-toggle-${p.id}`} />
      </div>
    </li>
  );
}
